import * as bd from 'react-basic-design';
import { useDashboardInitApiResult } from '../../../api/dashboard-api';
import settings from '../../../app/settings';
import { T } from '../../../components/basic/text';
import { SysMenuTiles } from './sys-menu/sysmenu-tiles';
import { ExpiringContracts } from '../../admin/contract-page/expiring-contracts';

export function HomeApp() {
    const initApiResult = useDashboardInitApiResult();

    const model = initApiResult;

    if (!model) return <></>;

    const style = {
        background: 'url(/images/bg/bg-map.png) center no-repeat',
        minHeight: 540,
    };

    if (!model.sysMenu.length) {
        return (
            <div className="middle pt-5" style={style}>
                <div className="text-center">
                    <T as="h5" className="text-muted">
                        app-title
                    </T>
                    <T as="h1" className="pb-5">
                        welcome
                    </T>
                    <div className="pt-5">
                        <T>you-dont-have-enough-permission-please-contact-administrator</T>
                    </div>
                    <div className="pt-5">
                        <T>support-tel</T>:{' '}
                        <span className="ltr d-inline-block">{settings.supportTel}</span>
                    </div>
                </div>
            </div>
        );
    }

    const home_tiles = model.sysMenu.filter(x => x.id?.toUpperCase() !== 'ADMIN');

    return (
        <bd.Flex className="pb-6" vertical>
            <div className="launchpad-container">
                <SysMenuTiles menus={home_tiles} />
            </div>

            <ExpiringContracts />
        </bd.Flex>
    );
}
